import { ADD_SNACK } from "../actionTypes";

const snackReducer = (state = null, action) => {
  switch (action.type) {
    case ADD_SNACK:
      return action.payload;

    default:
      return state;
  }
};

export default snackReducer;
